import {
  mapActions,
  mapState,
} from 'vuex';

import {
  utilities,
  valueFormatters,
} from '../../shared';

export default {
  name: "Card",
  props: {
    id: String,
    title: String,
    subtitle: String,
    abstract: String,
    link: String,
    linkLabel: String,
    customLinkLabel: String,
    connectToBillboard: Boolean,
    isKeyFact: Boolean,
    keyFactTitle: String,
    image: String,
    imageSrcSet:String,
    imageMobile: String,
    imageSrcSetMobile:String,
    video: String,
    date: String,
    tag: String,
    tagLink: String,
    pageType: String,
    theme: String,
    subitems: Object,
    isActive: Boolean,
    applications: Array,
    myIndex: Number,
    numbered: String,
    htmlContent: String,
    isCurrentPage: Boolean,
    size: String,
    startDate: String,
    endDate: String,
  },
  mixins: [utilities, valueFormatters],
  computed: {
    ...mapState(["billboardItem", "selectedCard"]),
    isSelected: function() {
      return this.selectedCard?.id === this.id;
    },
    isOnBillboard: function() {
      return this.billboardItem?.id === this.id;
    },
    hasSubitems: function() {
      return this.subitems?.length;
    },
    isNumbered: function() {
      return this.numbered && this.numbered == '1' ? true : false;
    },
    simpleStartDate: function() {
      return this.getDate(this.startDate)
    },
    simpleEndDate: function() {
      return this.getDate(this.endDate)
    },
    startDay: function() {
      return this.getDay(this.startDate)
    },
    endDay: function() {
      return this.getDay(this.endDate)
    },
    startMonth: function() {
      return this.getMonth(this.startDate)
    },
    endMonth: function() {
      return this.getMonth(this.endDate)
    },
    startYear: function() {
      return this.getYear(this.startDate)
    },
    endYear: function() {
      return this.getYear(this.endDate)
    }
  },
  methods: {
    ...mapActions(["setBillboardItem", "selectCard"]),
    toggleDetails() {
      if (this.selectedCard && this.selectedCard.id === this.id) {
        this.selectCard(undefined);
      } else {
        this.selectCard(this);
      }
    },
    sendToBillboard() {
      if (!this.isMobile() && this.connectToBillboard && !this.isKeyFact) {
        this.setBillboardItem(this);
      }
    },
  },
  watch: {
    isActive: function() {
      if (this.isActive && this.connectToBillboard && !this.isKeyFact) {
        this.setBillboardItem(this);
      }
    },
  },
  render() {
    return (
      this.$slots &&
      this.$slots.default &&
      this.$slots.default({
        id: this.id,
        title: this.title,
        subtitle: this.subtitle,
        abstract: this.abstract,
        link: this.link,
        linkLabel: this.linkLabel,
        customLinkLabel: this.customLinkLabel,
        connectToBillboard: this.connectToBillboard,
        isKeyFact: this.isKeyFact,
        keyFactTitle: this.keyFactTitle,
        image: this.image,
        imageSrcSet: this.imageSrcSet,
        imageMobile: this.imageMobile,
        imageSrcSetMobile: this.imageSrcSetMobile,
        video: this.video,
        theme: this.theme,
        subitems: this.subitems,
        isActive: this.isActive,
        billboardItem: this.billboardItem,
        selectedCard: this.selectedCard,
        isSelected: this.isSelected,
        isOnBillboard: this.isOnBillboard,
        hasSubitems: this.hasSubitems,
        setBillboardItem: this.setBillboardItem,
        selectCard: this.selectCard,
        toggleDetails: this.toggleDetails,
        sendToBillboard: this.sendToBillboard,
        date: this.date,
        tag: this.tag,
        tagLink: this.tagLink,
        pageType: this.pageType,
        truncateString: this.truncateString,
        stripHTML: this.stripHTML,
        applications: this.applications,
        myIndex: this.myIndex,
        isNumbered: this.isNumbered,
        htmlContent: this.htmlContent,
        isCurrentPage: this.isCurrentPage,
        size: this.size,
        startDate: this.startDate,
        endDate: this.endDate,
        simpleStartDate: this.simpleStartDate,
        simpleEndDate: this.simpleEndDate,
        startDay: this.startDay,
        endDay: this.endDay,
        startMonth: this.startMonth,
        endMonth: this.endMonth,
        startYear: this.startYear,
        endYear: this.endYear,
      })
    );
  },
};
